// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__25lDp","itemA":"Write_itemA__3960M","itemB":"Write_itemB__3-6jr","itemC":"Write_itemC__w7TZ8","itemD":"Write_itemD__10Z9y"};